import { useQuery } from '@tanstack/react-query'
import { useReserveOverlay } from '~/navigation'
import type { Result } from '~/routes/api.v2.restaurants.$restaurantId.detail'
import { DetailFusuma } from './GuideDetail'

// 予約導線で店舗詳細を表示するふすま
export function ReserveDetailFusuma() {
  const [context] = useReserveOverlay('DETAILS')
  const { data } = useQuery<Result>({
    queryKey: ['api.v2.restaurants.detail', context?.restaurantId],
    queryFn: async ({ queryKey: [_, restaurantId] }) => {
      const res = await fetch(`/api/v2/restaurants/${restaurantId}/detail`)
      return res.json()
    },
    enabled: context?.restaurantId !== undefined,
    staleTime: 10 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  })
  if (context === undefined) {
    return null
  }
  if (data === undefined || data.restaurant === null) {
    return null
  }
  return <DetailFusuma restaurant={data.restaurant} />
}
